import React from 'react';
import {Grid} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import {makeStyles} from "@material-ui/core/styles";
import {APP_DOMAIN_PREFIX} from '../../../environment';

const useStyles = makeStyles({
  root: {
    width: '100%',
    background: 'transparent',
    position: 'relative'
  },
  discountText: {
    background: '#FF1E6F',
    padding: 5,
    color: '#fff',
    borderRadius: 5
  },
  bestSellerTag: {
    position: 'absolute',
    top: 20,
    left: 20,
    background: 'rgba(255,255,255,0.85)',
    padding: '4px 12px',
    borderRadius: 4,
    letterSpacing: 1,
    margin: 0
  }
});

// Best-seller banner images (item.image) are complete, pre-designed marketing
// banners (farmer photo + product name/details baked in) — the card just
// frames the image full-bleed and overlays the BEST SELLER tag rather than
// rendering separate title/description text that would duplicate it.
function Index(props) {
  const classes = useStyles();
  let position = props?.item.image?.search("userImages");
  let imageUrl = APP_DOMAIN_PREFIX + props?.item?.image;
  if(position == -1)
   imageUrl = APP_DOMAIN_PREFIX + "/userImages/" + props?.item.image;

  return (

    <Card className={classes.root}>
      <div className='best-seller-banner-img-container' style={{position: 'relative'}}>
        <img src={imageUrl} className='best-seller-banner-img'/>
        <p className={['heading-color font-12', classes.bestSellerTag].join(' ')}>BEST SELLER</p>
        {!!props?.item.discountCapture && (
          <Grid className={['discount-tag', classes.discountText].join(' ')} style={{position: 'absolute', top: 20, right: 20}}>
            <p className='m-0 font-10 '>Flat {props?.item.discountCapture}% OFF</p>
          </Grid>
        )}
      </div>
    </Card>

  );
}

export default Index;
